var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypalActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1646 6.06836C19.1632 6.07825 19.1628 6.08052 19.1602 6.09818C19.1602 6.09818 19.1623 6.0838 19.1646 6.06836Z",
    fill: "#B0871C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1646 6.06689C19.1714 6.02106 19.1686 6.03966 19.1646 6.06689V6.06689Z",
    fill: "#B0871C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1486 1.80966C17.0372 0.54304 15.0284 0 12.4585 0H5.00005C4.47428 0 4.02747 0.38238 3.94518 0.90086L0.839598 20.597C0.777888 20.9854 1.07862 21.3372 1.47226 21.3372H6.07684L7.23329 14.0022L7.19743 14.2319C7.27976 13.7134 7.7232 13.331 8.24833 13.331H10.4364C14.7349 13.331 18.1007 11.5851 19.0839 6.53438C19.1131 6.38503 19.1603 6.09758 19.1603 6.09758C19.4391 4.22865 19.1583 2.96016 18.1486 1.80966Z",
    fill: "#B0871C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3258 7.05469C19.2567 12.0272 15.8465 14.6592 10.4365 14.6592H8.47412L7.01074 24.0006H10.1936C10.653 24.0006 11.044 23.6661 11.1157 23.2126L11.1536 23.0148L11.8851 18.3784L11.9323 18.1221C12.004 17.6687 12.395 17.3341 12.8544 17.3341H13.4353C17.1954 17.3341 20.1396 15.8066 21 11.3886C21.3448 9.61614 21.1796 8.1291 20.3258 7.05469Z",
    fill: "#B0871C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalActive);
export default __webpack_public_path__ + "static/media/paypal-active.562321cf.svg";
export { ForwardRef as ReactComponent };